import { useEffect, useRef } from "react";
import beinsports from "../assets/cover/chaine/Bein_Sports.png";
import antena3 from "../assets/cover/chaine/Antena_3.png";
import netflix from "../assets/cover/chaine/Netflix.png";
import primevideo from "../assets/cover/chaine/Prime_Video.png";
import disney from "../assets/cover/chaine/Disney+.png";
import atresplayer from "../assets/cover/chaine/Atresplayer.png";
import cuatro from "../assets/cover/chaine/Cuatro.png";
import hbomax from "../assets/cover/chaine/HBO_Max.png";
import discovery from "../assets/cover/chaine/Discovery.png";
import espn from "../assets/cover/chaine/ESPN.png";
import filmbox from "../assets/cover/chaine/Filmbox.png";
import appletvplus from "../assets/cover/chaine/Apple_TV.png";
import movistar from "../assets/cover/chaine/Movistar_Plus.png";
import plutotv from "../assets/cover/chaine/Pluto_TV.png";
import rakuten from "../assets/cover/chaine/Rakuten_TV.png";
import hulu from "../assets/cover/chaine/Hulu.png";
import skyshowtime from "../assets/cover/chaine/SkyShowtime.png";
import rtve from "../assets/cover/chaine/rtve.png";

export default function Chaine() {
  const carouselRef = useRef(null);
  const scrollInterval = useRef(null);

  // Block any manual scroll/drag while keeping programmatic autoplay
  const blockUserScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Import all film images
  const filmImages = [];
  for (let i = 1; i <= 38; i++) {
    try {
      const imagePath =
        i === 8 || i === 19
          ? require(`../assets/cover/film/${i}.jpg`)
          : require(`../assets/cover/film/${i}.webp`);
      filmImages.push(imagePath);
    } catch (error) {
      console.warn(`Could not load image ${i}`);
    }
  }

  
  // Import all chaine logos
  const chaineLogos = [
    { name: "Bein Sports", src: beinsports },
    { name: "Antena 3", src: antena3 },
    { name: "Netflix", src: netflix },
    { name: "Prime Video", src: primevideo },
    { name: "Disney+", src: disney },
    { name: "Atresplayer", src: atresplayer },
    { name: "Cuatro", src: cuatro },
    { name: "HBO Max", src: hbomax },
    { name: "Discovery", src: discovery },
    { name: "ESPN", src: espn },
    { name: "Filmbox", src: filmbox },
    { name: "Apple TV+", src: appletvplus },
    { name: "Movistar+", src: movistar },
    { name: "Pluto TV", src: plutotv },
    { name: "Rakuten TV", src: rakuten },
    { name: "Hulu", src: hulu },
    { name: "SkyShowtime", src: skyshowtime },
    { name: "RTVE", src: rtve },
  ];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    // Create infinite scroll effect
    const startInfiniteScroll = () => {
      scrollInterval.current = setInterval(() => {
        const singleSetWidth = carousel.scrollWidth / 3; // Since we have 3 copies
        const currentScroll = carousel.scrollLeft;
        
        // Reset to beginning when we've scrolled through one complete set
        if (currentScroll >= singleSetWidth) {
          carousel.scrollLeft = 0;
        } else {
          carousel.scrollLeft += 1;
        }
      }, 20); // Smooth 50fps animation
    };

    // Wait for images to load and carousel to be properly initialized
    const initializeCarousel = () => {
      // Check if all images are loaded
      const images = carousel.querySelectorAll('img');
      const loadedImages = Array.from(images).filter(img => img.complete);
      
      // If all images are loaded or after a reasonable timeout, start the carousel
      if (loadedImages.length === images.length || loadedImages.length > 0) {
        startInfiniteScroll();
      } else {
        // Wait for images to load with a maximum timeout
        setTimeout(() => {
          startInfiniteScroll();
        }, 500);
      }
    };

    // Start initialization after a short delay to ensure DOM is ready
    setTimeout(initializeCarousel, 100);

    return () => {
      if (scrollInterval.current) {
        clearInterval(scrollInterval.current);
      }
    };
  }, []);

  return (
    <>
      <section className="py-16 bg-slate-50">
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
          <div className="text-center mb-12">
            <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-black bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] mb-4 max-w-3xl leading-snug text-center">
              Transmisión ilimitada de las últimas películas, series y canales de TV en
              vivo
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Disfruta de contenido premium de las mejores plataformas de
              streaming en una sola suscripción
            </p>
          </div>

          {/* Infinite Carousel */}
          <div className="relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full bg-transparent z-10"></div>
            <div
              ref={carouselRef}
              className="flex space-x-4 overflow-hidden carousel-container"
              style={{
                scrollBehavior: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                touchAction: "none",
                overscrollBehaviorX: "contain",
              }}
              onWheel={blockUserScroll}
              onTouchStart={blockUserScroll}
              onTouchMove={blockUserScroll}
              onPointerDown={blockUserScroll}
              onMouseDown={blockUserScroll}
            >
              {[...filmImages, ...filmImages, ...filmImages].map(
                (image, index) => {
                  return (
                    <div
                      key={`${index}-${Math.random()}`}
                      className="flex-shrink-0 group relative"
                    >
                      <div className="relative w-48 h-80 md:w-52 md:h-[22rem] rounded-2xl overflow-hidden transition-all duration-500 shadow-md mb-2">
                        <img
                          src={image}
                          alt={`Film ${index + 1}`}
                          className="w-full h-full object-cover transition-transform duration-500 carousel-image"
                          draggable={false}
                          onDragStart={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  );
                }
              )}
            </div>
            {/* Edge fade overlays */}
            <div className="carousel-edge-left"></div>
            <div className="carousel-edge-right"></div>
          </div>
          {/* Streaming Services Grid */}
          <div className="mt-5">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {chaineLogos.map((logo, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 border border-gray-100"
                >
                  <div className="flex items-center justify-center h-8">
                    <img
                      src={logo.src}
                      alt={logo.name}
                      className="max-h-12 max-w-full object-contain filter group-hover:brightness-110 transition-all duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
